import { useEffect, useState } from "react";

import { LanguagesApp } from "./languagesApp";
import { useLanguage } from "./";

export const useRTL = () => {
  const { language } = useLanguage();

  const changeRTL = () => {
    const isRTL = language === LanguagesApp.Arabic;
    document.dir = isRTL ? "rtl" : "ltr";
    return isRTL;
  };

  const [isRTL, setIsRTL] = useState(changeRTL());

  useEffect(() => {
    setIsRTL(changeRTL());
  }, [language]);

  return { isRTL };
};
